import { render } from "./CorporateOrder.vue?vue&type=template&id=308425cb&scoped=true"
import script from "./CorporateOrder.vue?vue&type=script&lang=js"
export * from "./CorporateOrder.vue?vue&type=script&lang=js"

import "./CorporateOrder.vue?vue&type=style&index=0&id=308425cb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308425cb"]])

export default __exports__